import { useQuery } from '@tanstack/react-query';
import { mcpPendingActionsApi } from '~/lib/api/client';
import { aiPendingActionKeys } from '~/hooks/use-ai-pending-actions';

/**
 * Live pending-count badge for the AI pending-actions menu entry (docs/ai/17). Shares the page's
 * query key, so an approve/reject on the page updates the badge instantly; a 60s poll keeps it live
 * while actions are queued from chats/MCP elsewhere. Renders nothing at zero. Mounted only when the
 * System-scoped menu item is visible, so non-System admins never poll.
 */
export function AiPendingCountBadge() {
	const { data } = useQuery({
		queryKey: aiPendingActionKeys.list(),
		queryFn: async () => (await mcpPendingActionsApi.getAll(false)).data.items ?? [],
		refetchInterval: 60_000,
		refetchOnWindowFocus: true
	});

	const pending = data?.filter(a => a.status === 'Pending').length ?? 0;
	if (pending === 0) return null;

	return (
		<span className="ml-auto rounded-pill bg-warning px-1.5 py-px text-[10px] font-semibold tabular-nums text-warning-fg">{pending}</span>
	);
}
